export default __webpack_public_path__ + "static/media/googleplay_us_badge_web.e8dc3ce2.png";